import { compose, lifecycle, withProps } from 'recompose'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { tags, isLoading, isLoaded } from 'app/modules/tags/selectors'
import { fetchTagList } from 'app/modules/tags/actions'

const mapStateToProps = state => {
  return {
    tagsById: tags(state),
    _isLoaded: isLoaded(state),
    _isLoading: isLoading(state),
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  _fetchTagList: fetchTagList,
}, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      if (!this.props._isLoaded && !this.props._isLoading) {
        this.props._fetchTagList()
      }
    }
  }),
  withProps(({ _isLoaded }) => ({ isTagsByIdLoaded: _isLoaded })),
)



// WEBPACK FOOTER //
// ./src/scripts/components/shared/withTags.js